import { AppBar, Box, Tab, Tabs } from '@mui/material'
import { NavLink, Outlet, useLocation } from 'react-router-dom'

const stripSlash = (s) => s.replace(/\/+$/, '')
export const ServiceReportIndex = () => {
    const location = useLocation()
    const allTabs = [
        {
            label: `Total Requests Per Service`,
            value: `/revenue-reports/service-report/Total_Requests_Per_Service`,
        },
        {
            label: `Average Resolution Time`,
            value: `/revenue-reports/service-report/Average_Resolution_Time`,
        },
    ]

    const pathname = stripSlash(location.pathname) || '/revenue-reports/service-report/Total_Requests_Per_Service'
    const subTabValue =
        allTabs.find((tab) => pathname === stripSlash(tab.value) || pathname.startsWith(stripSlash(tab.value) + '/'))?.value ??
        '/revenue-reports/service-report/Total_Requests_Per_Service'
    return (
        <>
            <AppBar position="static" className="border-bottom" sx={{ boxShadow: 'none', background: 'transparent' }}>
                <Box>
                    <Tabs variant="scrollable" scrollButtons="auto" value={subTabValue}>
                        {allTabs.map((item, i) => (
                            <Tab key={i} style={{ textTransform: 'capitalize' }} label={item.label} value={item.value} component={NavLink} to={item.value} />
                        ))}
                    </Tabs>
                </Box>
            </AppBar>
            <div className="p-0 flex-fill mt-3 custom_scroll min-height-50vh">
                <Outlet />
            </div>
        </>
    )
}
